export default [
  'accounting2@foodforjoe.es',
  'flavia@foodforjoe.com',
  'teresa.sanchez@foodforjoe.es',
  'joan.cases@foodforjoe.es',
  'diego@foodforjoe.es',
  'rebeca@foodforjoe.es',
  'esther.lopez@foodforjoe.es',
  'antonella@foodforjoe.es',
  'laia@foodforjoe.es',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
];
